import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import {
  getClientEmail,
  getClientName,
  getClientPhone,
  getClientSurname,
  getClientUnconfirmedPhone,
  getIsLoggedIn,
} from 'src/store/client/selectors';
import { getIsMobile } from 'src/store/view/selectors';
import { ClientDataBanner } from './ClientDataBanner';

const mapStateToProps = (state) => ({
  name: getClientName(state),
  surname: getClientSurname(state),
  phone: getClientPhone(state),
  email: getClientEmail(state),
  isMobile: getIsMobile(state),
  isLoggedIn: getIsLoggedIn(state),
  unconfirmedPhone: getClientUnconfirmedPhone(state),
});

const connector = connect(mapStateToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;
export default connector(ClientDataBanner);
